import useUserHasPermission from "@/shared/hooks/use-useris.hook";
import { A_PROPERTY_INFORMATION_VISITS } from "@/src-refactor/modules/shared/model/const/property/ information-visits.const";
import { A_ASSOCIATES_TYPES } from "@/src-refactor/modules/shared/model/const/property/associates-types.conts";
import {
  A_BUSINESS_TYPE,
  C_BUSINESS_TYPE
} from "@/src-refactor/modules/shared/model/const/property/business-type.const";
import { A_CONDICTION_PROPERTY } from "@/src-refactor/modules/shared/model/const/property/condition-status.const";
import {
  A_PROPERTY_TYPES_FOR_PROJECT,
  A_REALESTATE_TYPES,
  C_REALESTATE_TYPES_IDS
} from "@/src-refactor/modules/shared/model/const/property/real-estate-type.const";
import { A_YES_AND_NOT } from "@/src-refactor/modules/shared/model/const/yes-and-not.conts";
import { I_GENERIC_ITEMS } from "@/src-refactor/modules/shared/model/interface/items.interface";
import { Grid } from "@mui/material";
import MxTypography from "@rf-l1/MxTypography";
import MxFormSubTitle from "@rf-l1/page/form/MxFormSubTitle";
import MxTooltipNormal from "@rf-l1/tooltip/MxTooltipNormal";
import MxFormErrorMessage from "@rf-l2/form/MxFormErrorMessage";
import MxFormFieldController from "@rf-l2/form/MxFormFieldController";
import MxFormSelectArrangementsTypeField from "@rf-l2/form/select/MxFormSelectArragementsField";
import MxFormSelectBusinessDetailTypeField from "@rf-l2/form/select/MxFormSelectBusinessDetailTypeField";
import MxFormL3AutoComplete from "@rf-l3/form/MxForml3AutoComplete";
import MxFormL3ConditionStatusPropertyField from "@rf-l3/form/MxFormL3ConditionStatusPropertyField";
import MxFormL3InputField from "@rf-l3/form/MxFormL3InputField";
import MxFormL3RushRadioDuoField from "@rf-l3/form/MxFormL3RushRadioDuo";
import MxFormL3TextThousandField from "@rf-l3/form/MxFormL3TextThousandField";
import { IEventChange } from "@rf-model/event-change.model";
import usePropertyFormHelp from "@rf/property/module/components/property-form/hooks/helps/usePropertyFormHelp";
import usePropertyHelpTypeLocations from "@rf/property/module/components/property-form/hooks/helps/usePropertyHelpTypeLocations";
import { usePropertyFormFeaturesState } from "@rf/property/module/components/property-form/store/slices/FormFeaturesSlice";
import { CPropertyFormKeys } from "@rf/property/module/components/property-form/util/schemas/property-schema/propertySchema";
import { useMemo } from "react";
import { useFormContext } from "react-hook-form";

const BusinessDataFormSectionForNormalProperty = () => {
  const { PROPERTY_TYPE } = usePropertyFormHelp();
  const { isProject, isEdit } = usePropertyHelpTypeLocations();
  const { userIsAgent } = useUserHasPermission();
  const { trigger, setValue } = useFormContext();

  const listTypeProperty = useMemo(
    () =>
      isProject
        ? A_PROPERTY_TYPES_FOR_PROJECT
        : A_REALESTATE_TYPES.filter(x => x.id != C_REALESTATE_TYPES_IDS.PROJECT),
    []
  );

  const canEditNameField = isEdit && userIsAgent();

  const canEditCollectionField = isEdit
    ? PROPERTY_TYPE.APARTMENT ||
      PROPERTY_TYPE.HOUSE ||
      PROPERTY_TYPE.PENTHOUSE ||
      PROPERTY_TYPE.TURISTIC ||
      PROPERTY_TYPE.PROJECT
    : false;

  const handleSelectTypeProperty = (
    e: IEventChange<I_GENERIC_ITEMS[]>,
    value: I_GENERIC_ITEMS[],
    lastSelected?: I_GENERIC_ITEMS
  ) => {
    trigger();
  };
  const handleSelectTypeBussines = (
    e: IEventChange<I_GENERIC_ITEMS[]>,
    value: I_GENERIC_ITEMS[],
    lastSelected?: I_GENERIC_ITEMS
  ) => {
    setValue(CPropertyFormKeys.condition_property, []);
  };

  return (
    <Grid container spacing={2}>
      <Grid container item xs={12}>
        <MxFormSubTitle label="Datos del Negocio" />
      </Grid>

      <Grid item xs={12} lg={4}>
        <MxFormL3AutoComplete
          withreacthookform={1}
          name={CPropertyFormKeys.type_property}
          label="Tipo de propiedad"
          items={listTypeProperty}
          onSelect={handleSelectTypeProperty}
        />
      </Grid>

      <Grid item xs={12} lg={4}>
        <MxTooltipNormal
          label="Ingrese únicamente el nombre del condominio, edificio, torre o residencial"
          placement="top-start"
        >
          <span>
            <MxFormL3InputField
              withreacthookform={1}
              name={CPropertyFormKeys.name_property}
              label="Nombre de la propiedad"
              disabled={canEditNameField}
            />
          </span>
        </MxTooltipNormal>
      </Grid>

      <Grid item xs={12} lg={4}>
        <MxFormL3AutoComplete
          withreacthookform={1}
          name={CPropertyFormKeys.business_types_property}
          label="Tipo de negocio"
          items={A_BUSINESS_TYPE}
          onSelect={handleSelectTypeBussines}
        />
      </Grid>

      <Grid item xs={12} lg={4}>
        <MxFormFieldController
          withreacthookform={1}
          name={CPropertyFormKeys.detail_business_property}
        >
          <MxFormSelectBusinessDetailTypeField label="Detalles del negocio" />
          <MxFormErrorMessage />
        </MxFormFieldController>
      </Grid>

      <Grid item xs={12} lg={4}>
        <UsesField />
      </Grid>

      <Grid item xs={12} lg={4}>
        <ConditionField />
      </Grid>

      <Grid item xs={12} lg={4}>
        <MxFormL3AutoComplete
          withreacthookform={1}
          name={CPropertyFormKeys.associates_type_property}
          items={A_ASSOCIATES_TYPES}
          label="Asociados"
        />
      </Grid>

      <Grid item xs={12} lg={4}>
        <MxFormFieldController
          withreacthookform={1}
          name={CPropertyFormKeys.arrangement_type_property}
        >
          <MxFormSelectArrangementsTypeField label="Tipo de arreglo" />
          <MxFormErrorMessage />
        </MxFormFieldController>
      </Grid>

      {!PROPERTY_TYPE.LAND && (
        <Grid item xs={12} lg={4}>
          <MxFormL3TextThousandField
            withreacthookform={1}
            label="Metros2 de construcción"
            name={CPropertyFormKeys.meter_construction_property}
          />
        </Grid>
      )}

      <Grid item xs={12} lg={4}>
        <MxFormL3TextThousandField
          withreacthookform={1}
          label="Metros2 de solar"
          name={CPropertyFormKeys.meter_land_property}
        />
      </Grid>

      <Grid item xs={12} lg={4}>
        <MxFormL3AutoComplete
          withreacthookform={1}
          name={CPropertyFormKeys.visit_type_property}
          label="Información de visitas"
          items={A_PROPERTY_INFORMATION_VISITS}
        />
      </Grid>

      <Grid item xs={12} lg={4}>
        <MxFormL3RushRadioDuoField
          withreacthookform={1}
          name={CPropertyFormKeys.is_habited_property}
          items={A_YES_AND_NOT}
          label="¿Está habitado?"
        />
      </Grid>

      {canEditCollectionField && (
        <Grid item xs={12} lg={4}>
          <MxFormL3AutoComplete
            withreacthookform={1}
            name={CPropertyFormKeys.is_collection_property}
            label="¿Esta propiedad es THE RE/MAX COLLECTION?"
            items={A_YES_AND_NOT}
          />
        </Grid>
      )}
    </Grid>
  );
};

export default BusinessDataFormSectionForNormalProperty;

const UsesField = () => {
  const { feature } = usePropertyFormFeaturesState();

  return (
    <MxFormL3AutoComplete
      withreacthookform={1}
      name={CPropertyFormKeys.uses_property}
      label="Uso del inmueble"
      items={feature?.usage || []}
      isMultiple
    />
  );
};
const ConditionField = () => {
  const { BUSINESS_TYPE } = usePropertyFormHelp();
  console.log(BUSINESS_TYPE);
  return (
    <MxFormL3ConditionStatusPropertyField
      isRent={BUSINESS_TYPE.isRent}
      name={CPropertyFormKeys.condition_property}
      label="Estado del inmueble"
      withreacthookform={1}
    />
  );
};
